import { SVGProps } from "react"

const Neutral = (props: SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.75 0C2.32 0 0 2.32 0 7.75V13.75C0 19.18 2.32 21.5 7.75 21.5H13.75C19.18 21.5 21.5 19.18 21.5 13.75V7.75C21.5 2.32 19.18 0 13.75 0H7.75ZM1.5 13.75V7.75C1.5 3.14 3.14 1.5 7.75 1.5H13.75C18.36 1.5 20 3.14 20 7.75V13.75C20 18.36 18.36 20 13.75 20H7.75C3.14 20 1.5 18.36 1.5 13.75ZM6.74994 4.5C6.74994 4.09 7.08994 3.75 7.49994 3.75L13.9388 3.75C14.3537 3.75 14.6899 4.08629 14.6899 4.50112C14.6899 4.91605 14.3535 5.25238 13.9386 5.25224L7.49994 5.25C7.08994 5.25 6.74994 4.91 6.74994 4.5Z"
		/>
	</svg>
)

const Stable = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.7183 14.0721C19.5683 13.9221 19.4983 13.7321 19.4983 13.5421C19.4983 13.3521 19.5683 13.1621 19.7183 13.0121C20.0083 12.7221 20.4883 12.7221 20.7783 13.0121L23.4494 15.6833C23.5313 15.7543 23.5975 15.8437 23.6404 15.9471C23.7104 16.1082 23.7216 16.2899 23.6739 16.4576C23.6403 16.5758 23.5775 16.6871 23.4854 16.7792C23.4837 16.7809 23.482 16.7825 23.4804 16.7842L20.7782 19.4863C20.4882 19.7763 20.0082 19.7763 19.7182 19.4863C19.4282 19.1963 19.4282 18.7163 19.7182 18.4263L21.1453 16.9992L13.9553 16.9992C13.5453 16.9992 13.2053 16.6592 13.2053 16.2492C13.2053 15.8392 13.5453 15.4992 13.9553 15.4992L21.1454 15.4992L19.7183 14.0721Z"
			fill="#AE69FF"
		/>
		<path
			d="M15 1.25H9C3.57 1.25 1.25 3.57 1.25 9V15C1.25 20.43 3.57 22.75 9 22.75H15C15.41 22.75 15.75 22.41 15.75 22C15.75 21.59 15.41 21.25 15 21.25H9C4.39 21.25 2.75 19.61 2.75 15V9C2.75 4.39 4.39 2.75 9 2.75H15C19.61 2.75 21.25 4.39 21.25 9C21.25 9.41 21.59 9.75 22 9.75C22.41 9.75 22.75 9.41 22.75 9C22.75 3.57 20.43 1.25 15 1.25Z"
			fill="currentColor"
		/>
		<path
			d="M8.74994 5C8.33994 5 7.99994 5.34 7.99994 5.75C7.99994 6.16 8.33994 6.5 8.74994 6.5L15.1886 6.50224C15.6035 6.50238 15.9399 6.16605 15.9399 5.75112C15.9399 5.33629 15.6037 5 15.1888 5L8.74994 5Z"
			fill="currentColor"
		/>
	</svg>
)

const Losing = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.7046 12.75C18.7046 12.34 19.0446 12 19.4546 12C19.8646 12 20.2046 12.34 20.2046 12.75V19.94L21.6316 18.5129C21.7816 18.3629 21.9716 18.2929 22.1616 18.2929C22.3516 18.2929 22.5416 18.3629 22.6916 18.5129C22.9816 18.8029 22.9816 19.2829 22.6916 19.5729L20.0211 22.2435C19.9495 22.3261 19.8594 22.3928 19.7551 22.4358C19.7466 22.4394 19.7381 22.4429 19.7296 22.4462C19.5748 22.5084 19.4059 22.5136 19.251 22.4699C19.1309 22.4367 19.0179 22.3734 18.9245 22.28C18.9218 22.2774 18.9192 22.2746 18.9165 22.2719L16.2175 19.5729C15.9275 19.2829 15.9275 18.8029 16.2175 18.5129C16.5075 18.2229 16.9875 18.2229 17.2775 18.5129L18.7046 19.94V12.75Z"
			fill="#AE69FF"
		/>
		<path
			d="M15 1.25H9C3.57 1.25 1.25 3.57 1.25 9V15C1.25 20.43 3.57 22.75 9 22.75H15C15.41 22.75 15.75 22.41 15.75 22C15.75 21.59 15.41 21.25 15 21.25H9C4.39 21.25 2.75 19.61 2.75 15V9C2.75 4.39 4.39 2.75 9 2.75H15C19.61 2.75 21.25 4.39 21.25 9C21.25 9.41 21.59 9.75 22 9.75C22.41 9.75 22.75 9.41 22.75 9C22.75 3.57 20.43 1.25 15 1.25Z"
			fill="currentColor"
		/>
		<path
			d="M8.74994 5C8.33994 5 7.99994 5.34 7.99994 5.75C7.99994 6.16 8.33994 6.5 8.74994 6.5L15.1886 6.50224C15.6035 6.50238 15.9399 6.16605 15.9399 5.75112C15.9399 5.33629 15.6037 5 15.1888 5L8.74994 5Z"
			fill="currentColor"
		/>
	</svg>
)

const Gaining = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.7046 21.7485C18.7046 22.1585 19.0446 22.4985 19.4546 22.4985C19.8646 22.4985 20.2046 22.1585 20.2046 21.7485V14.5586L21.6316 15.9856C21.7816 16.1356 21.9716 16.2056 22.1616 16.2056C22.3516 16.2056 22.5416 16.1356 22.6916 15.9856C22.9816 15.6956 22.9816 15.2156 22.6916 14.9256L20.0211 12.255C19.9495 12.1724 19.8594 12.1057 19.755 12.0627C19.7466 12.0591 19.7382 12.0556 19.7297 12.0523C19.5748 11.9901 19.4058 11.9849 19.2509 12.0286C19.1308 12.0619 19.0179 12.1252 18.9245 12.2185C18.9218 12.2212 18.9192 12.2239 18.9165 12.2266L16.2175 14.9256C15.9275 15.2156 15.9275 15.6956 16.2175 15.9856C16.5075 16.2756 16.9875 16.2756 17.2775 15.9856L18.7046 14.5585V21.7485Z"
			fill="#AE69FF"
		/>
		<path
			d="M15 1.25H9C3.57 1.25 1.25 3.57 1.25 9V15C1.25 20.43 3.57 22.75 9 22.75H15C15.41 22.75 15.75 22.41 15.75 22C15.75 21.59 15.41 21.25 15 21.25H9C4.39 21.25 2.75 19.61 2.75 15V9C2.75 4.39 4.39 2.75 9 2.75H15C19.61 2.75 21.25 4.39 21.25 9C21.25 9.41 21.59 9.75 22 9.75C22.41 9.75 22.75 9.41 22.75 9C22.75 3.57 20.43 1.25 15 1.25Z"
			fill="currentColor"
		/>
		<path
			d="M8.75043 5C8.34043 5 8.00043 5.34 8.00043 5.75C8.00043 6.16 8.34043 6.5 8.75043 6.5L15.189 6.50224C15.604 6.50238 15.9404 6.16605 15.9404 5.75112C15.9404 5.33629 15.6041 5 15.1893 5L8.75043 5Z"
			fill="currentColor"
		/>
	</svg>
)

const Null = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.55775 22.5431L5.99268 21.1075C6.4046 21.2323 6.84307 21.3 7.30005 21.3H9.0813V22.8H7.30005C6.69411 22.8 6.10915 22.7102 5.55775 22.5431ZM15.0188 22.8V21.3H16.8C17.257 21.3 17.6955 21.2323 18.1074 21.1075L18.5423 22.5431C17.991 22.7102 17.406 22.8 16.8 22.8H15.0188ZM19.6289 22.0926L18.9207 20.7703C19.7045 20.3505 20.3505 19.7044 20.7704 18.9206L22.0926 19.6289C21.5332 20.6734 20.6735 21.5331 19.6289 22.0926ZM22.8 9.08124H21.3V7.29999C21.3 6.84301 21.2324 6.40454 21.1076 5.99262L22.5432 5.55769C22.7102 6.10908 22.8 6.69405 22.8 7.29999V9.08124ZM22.0926 4.47111L20.7704 5.17934C20.3505 4.39553 19.7045 3.74949 18.9207 3.32967L19.6289 2.00739C20.6735 2.56688 21.5332 3.42655 22.0926 4.47111ZM9.0813 1.29999H7.30005C6.69411 1.29999 6.10915 1.38981 5.55775 1.55687L5.99268 2.99243C6.4046 2.86763 6.84307 2.79999 7.30005 2.79999H9.0813V1.29999ZM4.47117 2.00739L5.1794 3.32967C4.39559 3.74949 3.74955 4.39553 3.32973 5.17934L2.00746 4.4711C2.56694 3.42655 3.42661 2.56688 4.47117 2.00739ZM1.30005 15.0187H2.80005V16.8C2.80005 17.257 2.86769 17.6954 2.99249 18.1074L1.55693 18.5423C1.38987 17.9909 1.30005 17.4059 1.30005 16.8V15.0187ZM4.47117 22.0926L5.1794 20.7703C4.39559 20.3505 3.74955 19.7044 3.32973 18.9206L2.00745 19.6289C2.56694 20.6734 3.42661 21.5331 4.47117 22.0926ZM1.30005 13.8312H2.80005V10.2687H1.30005V13.8312ZM1.30005 9.08124H2.80005V7.29999C2.80005 6.84301 2.86769 6.40454 2.99249 5.99262L1.55693 5.55769C1.38987 6.10908 1.30005 6.69405 1.30005 7.29999V9.08124ZM10.2688 1.29999V2.79999H13.8313V1.29999H10.2688ZM15.0188 1.29999V2.79999H16.8C17.257 2.79999 17.6955 2.86763 18.1074 2.99243L18.5423 1.55687C17.991 1.38981 17.406 1.29999 16.8 1.29999H15.0188ZM22.8 10.2687H21.3V13.8312H22.8V10.2687ZM22.8 15.0187H21.3V16.8C21.3 17.257 21.2324 17.6954 21.1076 18.1074L22.5432 18.5423C22.7102 17.9909 22.8 17.4059 22.8 16.8V15.0187ZM13.8313 22.8V21.3H10.2688V22.8H13.8313Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 5.74999C8 5.33577 8.33579 4.99999 8.75 4.99999H15.15C15.5642 4.99999 15.9 5.33577 15.9 5.74999C15.9 6.1642 15.5642 6.49999 15.15 6.49999H8.75C8.33579 6.49999 8 6.1642 8 5.74999Z"
			fill="currentColor"
		/>
	</svg>
)

export const WeightIcon = Object.assign(Neutral, {
	Stable,
	Losing,
	Gaining,
	Null,
})
